import React, { useEffect, useState } from "react"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import { debounce } from "../../helpers/debounce"
import CampaignPaymentBills from "../../pages/campaigns/payments/bills"
import { useLanguage } from "@languages/index"

interface Props {
  className?: string
  onClick?: any

  style?: any
  preferences?: any
  history?: any

  showModal?: (params?: any) => void
  showSheet?: (params?: any) => void

  closeOverlays?: () => void
  showOverlays?: (params?: any) => void
}

const CampaignPaymentHistoryItemV1 = (props: Props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.component.campaignPaymentHistoryItem }

  const [isOpened, setIsOpened] = useState<boolean>(false)

  const toggleAccordion = () => {
    setIsOpened(!isOpened)
  }

  const showBills = () => {
    props.closeOverlays()
    debounce(() => {
      props.showOverlays({
        content: () => {
          return <CampaignPaymentBills {...props} history={props.history} />
        },
      })
    }, 400)
  }

  const renderMetaData = (metaDataJsonText:any) => {
    try {
      const metaData = JSON.parse(metaDataJsonText)

      const texts = []
      if (metaData?.tags?.is_additional_seeding)
        texts.push('추가 선정으로 인한 원고료')
      if (metaData?.tags?.is_commission_increased)
        texts.push('원고료 상향으로 인한 추가 비용')

      return texts.length > 0 ? (
        <div className="text-[12px] text-[#FF0000] font-bold">
          {`(${texts.join(' + ')})`}
        </div>
      ) : null

    } catch (e) {
      return null
    }
  }

  return (
    <div id={`campaign-payment-${props.history.id}`} className="flex flex-col">
      <div
        className="flex px-5 py-4 flex-row justify-around border-b border-grey-200 cursor-pointer gap-3"
        style={{
          ...{ backgroundColor: "rgba(0, 0, 0, 0.05)" },
          ...props.style,
        }}
        onClick={(e) => {
          //   toggleAccordion();
          e.preventDefault()
          showBills()
        }}
      >
        <span className="text-start flex-col items-center">
          <div className="flex flex-row">
            <span>{props.history.typeDesc}</span>
          </div>
          {props.history?.metaData != null
            ? renderMetaData(props.history.metaData)
            : null}
          {/* <div className="flex flex-row items-center">
            <span className="text-xs opacity-50 cursor-pointer">
              자세히 보기
            </span>
            <ChevronDown size={12} />
          </div> */}
        </span>
        <span className="flex-1 text-right items-center pl-3 tracking-tighter flex justify-end gap-1">
          {props.history.createdDate}

          <small
            className="ml-1 text-xs underline opacity-50 cursor-pointer"
            onClick={(e) => {
              e.preventDefault()
              showBills()
            }}
          >
            {languageTexts.bills}
          </small>
        </span>
      </div>
      {/* <Collapsible
        trigger={""}
        open={isOpened}
        transitionTime={300}
        easing={"ease"}
        onClick={() => {
          toggleAccordion();
        }}
      >
        <div className="flex flex-col px-5 py-4 gap-4">
          <div className="flex flex-row justify-between">
            <span className="text-sm opacity-50">사용된 날짜</span>
            <span className="text-sm opacity-50">사용 갯수</span>
          </div>

          {props.history.histories && props.history.histories.length ? (
            props.history.histories.map((history?: any, index?: number) => {
              return (
                <div
                  className="flex flex-col"
                  key={`histories${history.id}-${index}`}
                >
                  <div className="flex flex-row justify-between">
                    <span className="text-sm ">{history.createdDate}</span>
                    <span className="font-bold text-sm">
                      {Math.abs(history.amount)}
                    </span>
                  </div>
                  {index != props.history.histories.length - 1 ? (
                    <Divider style={{ borderColor: "black", opacity: 0.1 }} />
                  ) : null}
                </div>
              );
            })
          ) : (
            <div className="flex flex-row">
              <span className="text-sm">이용내역이 없습니다.</span>
            </div>
          )}
        </div>
      </Collapsible> */}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(CampaignPaymentHistoryItemV1)
